import React from 'react';

import { Box } from '../../../../../../Box';
import { VideoElementProps } from '../types';

export const HtmlPlayer = React.forwardRef<HTMLVideoElement, VideoElementProps>(
  (props, ref) => (
    <Box width="100%" height="100%" bgcolor="bg.dark.primary">
      <video {...props} ref={ref}>
        {props.children}
      </video>
    </Box>
  ),
);
